<template>
    <v-text-field
        :label='label'
        :prepend-icon='icon'
        maxlength="12"
        v-model='phoneData'
        :rules='[rules.phoneNumber]'
        @input='checkPhoneNumber'
    ></v-text-field>
</template>

<script>
import formRules from '@/mixins/formRules';

export default {
  name: 'phone-number-field',
  mixins: [formRules],
  props: {
    label: {
      required: true,
      type: String
    },
    icon: {
        required: true,
        type: String
    },
    activate: {
        required: false,
        type: Boolean,
        default: false
    },
    phone: {
        required: true,
        type: String,
        default: ''
    }
  },
  data: function () {
    return {
        phoneData: this.phone,
    };
  },
  methods: {
        checkPhoneNumber(){
            let phoneData = this.phoneData;
            if(phoneData === null || phoneData === ''){
                this.$emit('update', '');
                return;
            }

            if(phoneData.length === 4 && phoneData.charAt(3) !== '-'){
                phoneData = phoneData.slice(0, 3) + "-" + phoneData.slice(3, 5);
            }

            if(phoneData.length === 8 && phoneData.charAt(7) !== '-'){
                phoneData = phoneData.slice(0, 7) + "-" + phoneData.slice(7, 9);
            }

            if(phoneData.length === 13){
                phoneData = phoneData.slice(0, 12);
            }

            this.$emit('update', phoneData);
        }
    }
}
</script>
